import type {
  AvailableSlotsResponse,
  Booking,
  HealerSessionOption,
  PaymentOrder,
  SlotHold,
} from "@/features/booking/types/booking";
import type {
  AvailableSlotsResponseDto,
  BookingDto,
  HealerSessionOptionDto,
  PaymentOrderDto,
  SlotHoldDto,
} from "../dto/booking.dto";

export function mapAvailableSlotsDto(dto: AvailableSlotsResponseDto): AvailableSlotsResponse {
  return dto;
}

export function mapHealerSessionOptionsDto(dto: HealerSessionOptionDto[]): HealerSessionOption[] {
  return dto;
}

export function mapSlotHoldDto(dto: SlotHoldDto): SlotHold {
  return dto;
}

export function mapBookingDto(dto: BookingDto): Booking {
  return dto;
}

export function mapPaymentOrderDto(dto: PaymentOrderDto): PaymentOrder {
  return {
    ...dto,
    booking: mapBookingDto(dto.booking),
  };
}
